import constants from 'common/constants'

import {
  GET_APPLICATION_FEEDBACK_STATUS,
  SUBMIT_APPLICATION_FEEDBACK,
} from './ActionTypes/ApiActionType'

export const getApplicationFeedbackStatus = (onSuccess, onFailure) => {
  return {
    type: GET_APPLICATION_FEEDBACK_STATUS,
    payload: {
      apiUrl: constants.api_application_feedback_status,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const submitApplicationFeedback = (data, onSuccess, onFailure) => {
  return {
    type: SUBMIT_APPLICATION_FEEDBACK,
    payload: {
      apiUrl: constants.api_application_feedback_submit,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
